import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { Edit, Plus, Trash2, Loader } from 'lucide-react';
import useSWR from 'swr';

import NewCouponService from '../../services/coupon-service';
import { useAuth } from '../../contexts/AuthContext';

import { STATUS_MESSAGES } from '../../utils/api-handlers/http-status-code';
import { showToast } from '../../components/ToastConfig';

const STATUS_OPTIONS = [
  { value: '', label: '不限' },
  { value: 'active', label: '啟用' },
  { value: 'inactive', label: '停用' },
];

const SORTBY_OPTIONS = [
  { value: 'id', label: 'ID' },
  { value: 'validFrom', label: '起始日' },
  { value: 'validTo', label: '截止日' },
  { value: 'maxUsage', label: '可使用次數' },
  { value: 'createdAt', label: '建立日期' },
];

const SORT_OPTIONS = [
  { value: 'asc', label: '由小到大' },
  { value: 'desc', label: '由大到小' },
];

// SWR fetcher function
const fetcher = async ([url, keyword, status, from, to, sortBy, sort, page]) => {
  try {
    // Transform URL parameters to API parameters
    const apiParams = {
      search: keyword,
      isEnabled: status === 'inactive' ? false : status === 'active' ? true : null,
      validFrom: from ? from?.replaceAll("-", "/") : "",
      validTo: to ? to?.replaceAll("-", "/") : "",
      sortOrder: sortBy || "id",
      sortDirection: sort === 'asc' ? 'Ascending' : 'Descending',
      page
    };
    const res = await NewCouponService.search(apiParams, page);
    return res.data;
  } catch (error) {
    if (error.response?.status === 400 && ["1002", "8000"].includes(error.response?.data?.errorCode)) {
      return { data: [], pagination: { totalCount: 0 } };
    }
    throw error;
  }
};

function MemberSubscriptionList() {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const [searchInput, setSearchInput] = useState(searchParams.get('keyword') || '');
  // const [pageInput, setPageInput] = useState(searchParams.get('page') || '1');
  // const [isComposing, setIsComposing] = useState(false);
  // const Navigate = useNavigate();
  // const { logout } = useAuth();

  // // Get search parameters from URL
  // const keyword = searchParams.get('keyword') || '';
  // const status = searchParams.get('status') || '';
  // const from = searchParams.get('from') || '';
  // const to = searchParams.get('to') || '';
  // const sortBy = searchParams.get('sortBy') || 'id';
  // const sort = searchParams.get('sort') || 'desc';
  // const page = parseInt(searchParams.get('page') || '1');
  // const pageSize = 10;

  // // Use SWR to fetch data
  // const { data, error, isLoading, mutate } = useSWR(
  //   ['/api/CouponManagement/Search', keyword, status, from, to, sortBy, sort, page],
  //   fetcher,
  //   {
  //     onError: (err) => {
  //       if (error?.response?.status === 401 || error?.response?.status === 403) {
  //         logout();
  //       } else if (err.response?.status !== 400) {
  //         const errorMessage = STATUS_MESSAGES[err.response?.status] || STATUS_MESSAGES["default"];
  //         showToast.error(errorMessage);
  //       }
  //     },
  //     revalidateOnFocus: false,
  //   }
  // );

  // const [couponsWithStatus, setCouponsWithStatus] = useState([]);
  // const coupons = data?.data || [];
  // const totalItems = data?.pagination?.totalCount || 0;
  // const totalPages = Math.ceil(totalItems / pageSize);

  // useEffect(() => {
  //   if (coupons.length > 0) {
  //     setCouponsWithStatus(coupons.map(coupon => ({
  //       ...coupon,
  //       isUpdating: false
  //     })));
  //   }
  // }, [coupons]);

  // const handleToggleStatus = async (e, couponId, newStatus) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   // Update local state to show loading
  //   setCouponsWithStatus(prev => prev.map(coupon => 
  //     coupon.id === couponId 
  //       ? { ...coupon, isUpdating: true }
  //       : coupon
  //   ));

  //   const targetCoupon = couponsWithStatus.find(coupon => coupon.id === couponId);
    
  //   if (!targetCoupon) {
  //     console.error('Target coupon not found');
  //     showToast.error('更新狀態失敗，請稍後再試');
  //     return;
  //   }

  //   const { validFrom, validTo, maxUsage, name } = targetCoupon;

  //   try {
  //     await NewCouponService.update(couponId, {validFrom, validTo, maxUsage, name, isEnabled: newStatus});
  //     mutate(); // Refresh the data
  //     showToast.success(newStatus ? '優惠券已啟用' : '優惠券已停用');
  //   } catch (error) {
  //     console.error('Error updating coupon status:', error);
  //     if (error?.response?.status === 401 || error?.response?.status === 403) {
  //       logout();
  //     } else {
  //       showToast.error('更新狀態失敗，請稍後再試');
  //     }

  //     // Revert local state on error
  //     setCouponsWithStatus(prev => prev.map(coupon => 
  //       coupon.id === couponId 
  //         ? { ...coupon, isUpdating: false }
  //         : coupon
  //     ));
  //   }
  // };

  // // Handle search params update
  // const updateSearchParams = useCallback((updates) => {
  //   const newParams = new URLSearchParams(searchParams);
  //   Object.entries(updates).forEach(([key, value]) => {
  //     if (value) {
  //       newParams.set(key, value);
  //     } else {
  //       newParams.delete(key);
  //     }
  //   });
  //   setSearchParams(newParams);
  //   if (updates.page) {
  //     setPageInput(updates.page);
  //   }
  // }, [searchParams, setSearchParams]);

  // // Search debounce
  // useEffect(() => {
  //   if (isComposing) return;
  //   if (searchInput === keyword) return;

  //   const timer = setTimeout(() => {
  //     updateSearchParams({ keyword: searchInput, page: '1' });
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [searchInput, isComposing, updateSearchParams, keyword]);

  // const handleDelete = async (e, couponId) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   if (!window.confirm('確定要刪除此優惠券嗎？此操作無法復原。')) {
  //     return;
  //   }

  //   try {
  //     await NewCouponService.delete(couponId);
  //     mutate();
  //     showToast.success('優惠券已刪除');
  //   } catch (error) {
  //     console.error('Error removing coupon:', error);
  //     if (error?.response?.status === 401 || error?.response?.status === 403) {
  //       logout();
  //     } else {
  //       showToast.error('刪除失敗，請稍後再試');
  //     }
  //   }
  // };
  
  // const handleViewUsedRecords = (e, id) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   Navigate(`/coupon/${id}/usage-records`);
  // }

  return (
    <div className="p-6 pt-0 min-h-[80vh] max-h-[80vh] overflow-auto">
      <div className="container mx-auto">
        <div className="sticky top-0 pt-6 pb-4 bg-white z-10">
          <h1 className="text-2xl font-bold">訂單管理</h1>
          <Link to="/member/subscription/1" className='underline text-blue-600 mt-4 block'>訂單內容頁面</Link>
          
          {/* Search and filter controls */}
          {/* <div className="space-y-4">
            <div className="flex justify-between mt-4">
              <div className="flex items-center">
                <Link className='flex items-center gap-2' to="/subscription/coupon/new">
                    <Plus size={28} className='border border-gray-600 rounded-full p-1' />
                    <span>新增</span>
                </Link>
              </div>
              <div className="flex gap-4">
                <input
                  type="text"
                  placeholder="搜尋名稱或代碼"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onCompositionStart={() => setIsComposing(true)}
                  onCompositionEnd={() => setIsComposing(false)}
                  className="px-3 py-2 border rounded"
                />
                <div className='relative' onClick={() => document.getElementById('from-date').showPicker()}>
                  <input
                    id="from-date"
                    type="date"
                    value={from}
                    onChange={(e) => updateSearchParams({ from: e.target.value, page: '1' })}
                    className="px-3 py-2 border rounded"
                  />
                  {!from && (
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500 bg-white w-[6rem] h-fit my-auto ml-0.5">
                      起始日
                    </div>
                  )}
                </div>
                <div className='relative' onClick={() => document.getElementById('to-date').showPicker()}>
                  <input
                    id="to-date"
                    type="date"
                    value={to}
                    onChange={(e) => updateSearchParams({ to: e.target.value, page: '1' })}
                    className="px-3 py-2 border rounded"
                  />
                  {!to && (
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500 bg-white w-[6rem] h-fit my-auto ml-0.5">
                      截止日
                    </div>
                  )}
                </div>
                <select
                  value={status}
                  onChange={(e) => updateSearchParams({ status: e.target.value, page: '1' })}
                  className="px-3 py-2 border rounded"
                >
                  {STATUS_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                <select
                  value={sortBy}
                  onChange={(e) => updateSearchParams({ sortBy: e.target.value, page: '1' })}
                  className="px-3 py-2 border rounded"
                >
                  {SORTBY_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                <select
                  value={sort}
                  onChange={(e) => updateSearchParams({ sort: e.target.value, page: '1' })}
                  className="px-3 py-2 border rounded"
                >
                  {SORT_OPTIONS.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div> */}
        </div>

        {/* Loading state */}
        {/* {isLoading && (
          <div className="text-center py-8 text-gray-500 flex items-center justify-center">
            <Loader className="mr-1 animate-spin w-5 h-5" />
            載入中...
          </div>
        )} */}

        {/* Error state */}
        {/* {error && !isLoading && (
          <div className="text-center py-8 text-red-500">
            載入資料時發生錯誤，請稍後再試
          </div>
        )} */}

        {/* Empty state */}
        {/* {!isLoading && !error && coupons.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            {keyword || status || sort ? '沒有符合搜尋條件的優惠券' : '目前沒有任何優惠券'}
          </div>
        )} */}

        {/* Account list */}
        {/* {!isLoading && !error && coupons.length > 0 && (
          <div className="space-y-2">
            
            <div className="flex items-center p-4 bg-gray-50 rounded-t border-b font-medium justify-between">
              <div className="flex-1 flex">
                <div className="w-[5%]">ID</div>
                <div className="w-[15%]">名稱</div>
                <div className="w-[15%]">代碼</div>
                <div className="w-[20%]">期限</div>
                <div className="w-[10%]">可使用次數</div>
                <div className="w-[10%]">已使用次數</div>
                <div className="w-[7.5%]">啟用</div>
                <div className="w-[7.5%]">刪除</div>
                <div className="w-[10%]">建立日期</div>
              </div>
            </div>

            {coupons.map(coupon => (
              <Link key={coupon.id} to={`/subscription/coupon/${coupon.id}`} className="flex items-center p-4 border rounded hover:bg-gray-50 justify-between">
                <div className="flex-1 flex">
                  <div className="w-[5%] overflow-auto">#{coupon.id}</div>
                  <div className="w-[15%] overflow-auto">{coupon.name || `(無名稱)`}</div>
                  <div className="w-[15%] overflow-auto">{coupon.code}</div>
                  <div className="w-[20%] overflow-auto">{coupon.validFrom}-{coupon.validTo}</div>
                  <div className="w-[10%] overflow-auto">{coupon.maxUsage}</div>
                  <div className="w-[10%] overflow-auto flex items-center">{coupon.usedCount}</div>
                  <div className="w-[7.5%]">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleToggleStatus(e, coupon.id, coupon.isEnabled !== true);
                      }}
                      disabled={coupon.isUpdating}
                      className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 -ml-1.5
                        ${coupon.isEnabled === true ? 'bg-green-600 bg-opacity-20' : 'bg-gray-200'}
                        ${coupon.isUpdating ? 'cursor-not-allowed' : ''}
                      `}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full transition-transform duration-300 ${
                          coupon.isEnabled === true ? 'translate-x-8 bg-green-600' : 'translate-x-1 bg-gray-400'
                        }`}
                      />
                      <span 
                        className={`absolute text-md ${
                          coupon.isEnabled === true
                            ? 'left-2 text-green-600'
                            : 'right-2 text-gray-500'
                        }`}
                      >
                        {coupon.isEnabled === true ? '是' : '否'}
                      </span>
                    </button>
                  </div>
                  <div className="w-[7.5%] flex items-center">
                    <button
                      onClick={(e) => handleDelete(e, coupon.id)}
                      className="text-red-500 hover:text-red-700 ml-1.5"
                    >
                      <Trash2 size={22} />
                    </button>
                  </div>
                  <div className="w-[10%] overflow-auto">{coupon.createdAt}</div>
                </div>
              </Link>
            ))}
          </div>
        )} */}

        {/* Pagination */}
        {/* {totalPages > 1 && (
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-4 fixed bottom-[4%] w-[calc(100%-15rem)]">
            <div className="flex items-center">
              <span className="text-gray-700">第</span>
              <input
                type="text"
                className="w-16 mx-2 px-2 py-1 border rounded text-center"
                value={pageInput}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setPageInput(value);
                }}
                onBlur={() => {
                  const pageNum = parseInt(pageInput);
                  if (isNaN(pageNum) || pageNum < 1 || pageNum > totalPages) {
                    setPageInput(page.toString());
                  }
                }}
              />
              <span className="text-gray-700">頁</span>
            </div>
            
            <div className="flex flex-wrap justify-center gap-2 w-full md:w-auto px-4">
              <button
                onClick={() => updateSearchParams({ page: String(page - 1) })}
                disabled={page === 1}
                className={`px-3 py-1 border rounded ${
                  page === 1 ? 'text-gray-400' : 'hover:bg-gray-100'
                }`}
              >
                上一頁
              </button>
              
              <button
                onClick={() => updateSearchParams({ page: '1' })}
                className={`px-3 py-1 border rounded ${
                  1 === page ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                }`}
              >
                1
              </button>

              {page > 6 && <span className="px-3 py-1">...</span>}

              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(pageNum => {
                  const showRange = 4;
                  return pageNum > page - showRange && pageNum < page + showRange;
                })
                .filter(pageNum => pageNum !== 1 && pageNum !== totalPages)
                .map(pageNum => (
                  <button
                    key={pageNum}
                    onClick={() => updateSearchParams({ page: String(pageNum) })}
                    className={`px-3 py-1 border rounded ${
                      pageNum === page ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                    }`}
                  >
                    {pageNum}
                  </button>
                ))}

              {page < totalPages - 5 && <span className="px-3 py-1">...</span>}

              {totalPages > 1 && (
                <button
                  onClick={() => updateSearchParams({ page: String(totalPages) })}
                  className={`px-3 py-1 border rounded ${
                    totalPages === page ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                  }`}
                >
                  {totalPages}
                </button>
              )}

              <button
                onClick={() => updateSearchParams({ page: String(page + 1) })}
                disabled={page === totalPages}
                className={`px-3 py-1 border rounded ${
                  page === totalPages ? 'text-gray-400' : 'hover:bg-gray-100'
                }`}
              >
                下一頁
              </button>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}

export default MemberSubscriptionList;